import * as $http from 'axios';

export default {
  count: (params) => $http.get(`/customers/v2/category/count`, { params }),
};
